(() => {
  const sections = [...document.querySelectorAll('[data-cart-combos]')];
  if (!sections.length) return;
  const root = sections[0].dataset.root.replace(/\/$/, '');
  let catalogPromise;
  let version = 0;
  const cache = new Map();
  const catalog = () => catalogPromise ||= fetch(sections[0].dataset.catalogUrl).then(response => { if (!response.ok) throw new Error('catalog'); return response.json(); });
  const product = handle => {
    if (!cache.has(handle)) cache.set(handle,fetch(`${root}/products/${encodeURIComponent(handle)}.js`).then(response => { if (!response.ok) throw new Error('product'); return response.json(); }));
    return cache.get(handle);
  };
  const element = (tag,text) => { const node = document.createElement(tag); if (text) node.textContent = text; return node; };
  async function selectCartRecommendations(descriptors, cart, loadProduct, limit = 10) {
    const clothing = new Set(['top', 'bottom', 'dress']);
    const accessories = new Set(['cap', 'glasses', 'accessory']);
    const existing = new Set(cart.items.map(item => String(item.product_id)));
    const anchors = cart.items.map(item => descriptors.find(record => String(record.id) === String(item.product_id))).filter(record => record && ['man', 'woman', 'kids'].includes(record.gender) && clothing.has(record.kind) && record.brand !== 'royal white');
    const primary = anchors[0];
    const genders = new Set(anchors.map(record => record.gender));
    const compatibleClothes = record => clothing.has(record.kind) && genders.has(record.gender);
    const compatibleAccessory = record => record.gender === 'unisex' || genders.has(record.gender);
    const candidates = descriptors.filter(record => !existing.has(String(record.id)) && record.stock > 0);
    const chosen = [];
    const used = new Set();
    const take = async (pool, count) => {
      let added = 0;
      for (const candidate of pool) {
        if (chosen.length >= limit || added >= count) break;
        const id = String(candidate.id);
        if (used.has(id)) continue;
        used.add(id);
        try {
          const detail = await loadProduct(candidate.handle);
          if (!detail.variants.some(variant => variant.available)) continue;
          chosen.push(detail);
          added += 1;
        } catch (_) {}
      }
    };
    if (primary) await take(candidates.filter(record => clothing.has(record.kind) && record.brand === primary.brand && record.gender === primary.gender), 3);
    await take(candidates.filter(record => record.kind === 'perfume' && record.gender === 'unisex'), 2);
    await take(candidates.filter(record => accessories.has(record.kind) && compatibleAccessory(record)).sort((a, b) => Number(b.kind === 'glasses') - Number(a.kind === 'glasses')), 2);
    if (primary) await take(candidates.filter(record => compatibleClothes(record) && record.brand !== primary.brand).sort((a, b) => Number(b.brand === 'monastery') - Number(a.brand === 'monastery')), 1);
    await take(candidates.filter(record => ['shoe', 'bag'].includes(record.kind) && compatibleAccessory(record)).sort((a, b) => Number(b.kind === 'shoe') - Number(a.kind === 'shoe')), 2);
    await take(candidates.filter(record => compatibleClothes(record) || (accessories.has(record.kind) || ['shoe', 'bag'].includes(record.kind)) && compatibleAccessory(record)), limit - chosen.length);
    return chosen;
  }
  const refresh = async suppliedCart => {
    const revision = ++version;
    try {
      const cart = suppliedCart || await fetch(`${root}/cart.js`).then(response => response.json());
      if (revision !== version) return;
      if (!cart.items.length) { sections.forEach(section => {section.hidden = true; section.querySelector('[data-cart-combo-cards]').replaceChildren();}); return; }
      const descriptors = await catalog();
      const suggestions = await selectCartRecommendations(descriptors, cart, product, 10);
      if (revision !== version) return;
      sections.forEach(section => {
        const container = section.querySelector('[data-cart-combo-cards]');
        container.replaceChildren();
        section.hidden = !suggestions.length;
        const money = cents => new Intl.NumberFormat('es-CO',{style:'currency',currency:cart.currency || section.dataset.currency || 'COP',maximumFractionDigits:0}).format(cents / 100);
        suggestions.forEach(detail => {
          const card = element('article'); card.className = 'rw-cart-combo';
          const imageLink = element('a'); imageLink.href = `${root}/products/${encodeURIComponent(detail.handle)}`;
          const image = element('img'); image.src = detail.featured_image || ''; image.alt = detail.title; image.loading = 'lazy'; imageLink.append(image);
          const info = element('div');
          const title = element('a',detail.title); title.href = imageLink.href;
          const price = element('p');
          const select = element('select'); select.setAttribute('aria-label',`${section.dataset.size}: ${detail.title}`);
          detail.variants.filter(variant => variant.available).forEach(variant => { const option = element('option',variant.title === 'Default Title' ? section.dataset.oneSize : variant.title); option.value = String(variant.id); select.append(option); });
          const updatePrice = () => {price.textContent = money(detail.variants.find(variant => String(variant.id) === select.value).price);};
          select.addEventListener('change',updatePrice); updatePrice();
          const button = element('button',section.dataset.add); button.type = 'button'; button.className = 'btn';
          button.addEventListener('click',async () => {
            const status = section.querySelector('[data-cart-combo-status]'); status.textContent = ''; button.disabled = true; button.textContent = section.dataset.adding;
            try {
              const response = await fetch(`${root}/cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(select.value),quantity:1}]})});
              if (!response.ok) throw new Error('cart');
              const result = await fetch(`${root}/cart.js`); if (!result.ok) {window.location.href = `${root}/cart`; return;}
              const updated = await result.json();
              if (document.querySelector('.cart')) {window.location.reload(); return;}
              document.dispatchEvent(new CustomEvent('royal:quick-buy-added',{detail:{cart:updated}}));
            } catch (_) {status.textContent = section.dataset.error; button.disabled = false; button.textContent = section.dataset.add;}
          });
          info.append(title,price,select,button); card.append(imageLink,info); container.append(card);
        });
      });
    } catch (_) {if (revision === version) sections.forEach(section => section.hidden = true);}
  };
  document.addEventListener('royal:cart-updated',event => refresh(event.detail.cart));
  refresh();
})();
